import React from 'react';

function CenterButtons({ changeComponent }) {
  const handleClick = (event) => {
    const { id } = event.target;
    changeComponent(id);
  };

  return (
    <div className="center-button-content">
      <button className="action-button" id="assign" onClick={handleClick}>ASSIGN ANT</button>
      <button className="action-button" id="assigned" onClick={handleClick}>ASSIGNED ANTS</button>
    </div>
  );
}

export default CenterButtons;